/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum mccs_charge_related_kind {
  CASE = 'case',
  CERTIFICATE = 'certificate',
  APPLICATION = 'application',
}
